module.exports = __webpack_public_path__ + "static/media/render-garden.9642da17.png";